<template>
  <div style="display: inline-block;">
    <button class="custom-tooltip" v-b-tooltip="label">
      <img src="@/assets/images/icons/info.svg" />
    </button>
  </div>
</template>
<script>
export default {
  name: "TooltipComponent",
  props: ["label"]
};
</script>
<style lang="scss">
.custom-tooltip {
  display: inline-block;
  margin-left: 10px;
  padding-right: 10px;
  background: none;
}
.tooltip-inner {
  opacity: 1;
  color: #f6f6f6;
  background-color: #32302f;
  border-radius: 8px;
  text-align: left;
  max-width: 300px;
  padding: 10px 20px;
  font-family: "Nunito Sans";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 25px;
}

@media only screen and (max-width: 800px) {
  .custom-tooltip {
    display: inline-flex;
  }
}
</style>